/**
 * Anni ammessi per `reference_year` sulla creazione di un report Best Execution.
 *
 * Il BE ne accetta due, l'anno corrente o il precedente, e altrimenti risponde
 * 422 ("reference_year must be 2025 or 2026, got 2024"). Qui per ora se ne offre
 * uno solo, l'anno precedente: un report annuale copre l'anno chiuso, e l'anno
 * in corso non ha ancora dati completi. Per riaprire la scelta basta rimettere
 * `current` nella lista, il BE lo accetta gia'.
 */
export const referenceYearOptions = (today: Date = new Date()): number[] => {
  const current = today.getFullYear();
  return [current - 1];
};

/**
 * Default: l'anno precedente. Un report annuale prodotto a inizio anno copre
 * l'anno appena chiuso.
 */
export const defaultReferenceYear = (today: Date = new Date()): number =>
  today.getFullYear() - 1;
